<template>
  <div id="container">
    <div id="cons_container">
      <div class="header">
        <div class="time">
          {{ nowTime }}
        </div>
        <div class="header_title">
          {{this.$store.getters.getHeaderTitle}}
        </div>
        <div class="header_right">
          <span style="color: #ccc;margin-right: 3px">Welcome {{ user }}</span>
          <el-dropdown @command="handleCommand">
            <el-button icon="el-icon-user" circle size="medium"
                       style="background-color:#404040;color:#aaaaaa;border-width: 0px"></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">Change Password</el-dropdown-item>
              <el-dropdown-item :command="3">Manage Users</el-dropdown-item>
              <!--<el-dropdown-item @click.native="$router.push({path: '/login'})">Login Out</el-dropdown-item>-->
              <el-dropdown-item :command="2">Logout</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="header_medium">
          <div class="left">
            <a class="item active one" href="javascript:void(0)" @click="jump('1')">Home</a>
            <a class="item two" href="javascript:void(0)">Manpower</a>
            <a class="item three" href="javascript:void(0)" @click="jump('3')">Safety</a>
            <a class="item four" href="javascript:void(0)" @click="jump('4')">Quality</a>
          </div>
          <div class="medium">
            {{ startTimes }}
          </div>
          <div class="right">
            <a href="javascript:void(0)">Tower Crane</a>
            <a href="javascript:void(0)">CCTV</a>
            <a :href="vraddress">VR720</a>
            <a href="javascript:void(0)">Material</a>
          </div>
        </div>
      </div>
      <div class="constractor">
        <div class="cons_item item-1" style="grid-column: 1/2;grid-row: 1/2">
          <staff v-bind:cons_id="constractor_id"></staff>
        </div>
        <div class="cons_item item-2" style="grid-column: 1/2;grid-row: 2/3">
          <workers></workers>
        </div>
        <div class="cons_item item-3" style="grid-column: 1/2;grid-row: 3/4">
          <equipment></equipment>
        </div>
        <div class="cons_item item-4" style="grid-column: 2/4;grid-row: 1/3">
          <proj_map></proj_map>
        </div>
        <div class="cons_item item-5" style="grid-column: 2/3;grid-row: 3/4">
          <incidentn></incidentn>
        </div>
        <div class="cons_item item-6" style="grid-column: 3/4;grid-row: 3/4">
          <incident></incident>
        </div>
        <div class="cons_item item-7"
             style="grid-column: 4/5;grid-row: 1/3; display: grid; grid-template-columns: repeat(2, 50%); grid-template-rows: repeat(2, 50%)">
          <div style="grid-column: 1/3;grid-row: 1/2">
            <tbm></tbm>
          </div>
          <div style="grid-column: 1/3;grid-row: 2/3">
            <ptw></ptw>
          </div>
        </div>
        <div class="cons_item item-8" style="grid-column: 4/5;grid-row: 3/4">
          <safety></safety>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import proj_map from '@/components/proj_map/proj_map'
import staff from '@/components/constractor/staff'
import workers from '@/components/constractor/workers'
import tbm from '@/components/constractor/tbm'
import safety from '@/components/constractor/safety'
import equipment from '@/components/constractor/equipment'
import ptw from '@/components/constractor/ptw'
import incident from '@/components/constractor/incident'
import incidentn from '@/components/constractor/incidentn'

export default {
  name: "constractor",
  data() {
    return {
      constractor_id: '',
      nowTime: '',
      startDate: '2018-08-15',
      startTimes: '',
      vraddress:this.$store.getters.getVrAddress,
      user: window.localStorage.getItem("cons_name"),
    }
  },
  methods: {
    handleCommand(command) {
      if (command === 1) {
        this.$router.push("/changepwd")
      } else if (command === 2) {
        window.localStorage.clear();
        this.$router.push("/login")
      } else if (command === 3) {
        let routeData = this.$router.resolve({
          name: 'manageuser'
        });
        window.open(routeData.href, '_blank');
      }
    },
    timeFormat() {
      let timeStamp = new Date()
      let week = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
      let year = new Date(timeStamp).getFullYear();
      let month = months[new Date(timeStamp).getMonth()];
      let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
      let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
      let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
      let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
      let weekday = week[new Date(timeStamp).getDay()];
      this.nowTime = date + " " + month + " " + year + " " + hh + ":" + mm + ":" + ss + " " + weekday;
      let startDate = Date.parse(this.startDate)
      let dateSpan = startDate - timeStamp
      dateSpan = Math.abs(dateSpan)
      this.startTimes = "Safety Man-hours：" + Math.floor(dateSpan / (24 * 3600 * 1000)) + " d " + hh + " h " + mm + " m " + ss + " s"
    },
    nowTimes() {
      this.timeFormat();
    },
  },
  components: {
    proj_map,
    staff,
    workers,
    tbm,
    safety,
    equipment,
    ptw,
    incident,
    incidentn
  },
  mounted() {
    // if(window.localStorage.getItem('cons_id') && window.localStorage.getItem('cons_id')!= "") {
    this.$store.dispatch('saveCompanyId', window.localStorage.getItem('cons_id'))
    this.constractor_id = window.localStorage.getItem('cons_id')
    // }
    this.timer = setInterval(this.nowTimes, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
html, body, #container {
  height 100%
  width 100%
  background #24293c
  margin 0 auto
}

#cons_container {
  position relative
  margin: auto;
  width 1440px
  height 800px
  font-size 80px
}

.header {
  width: 100%;
  height: 18%;
  position: relative
  font-size 0.35em
}

.header_title {
  position: relative;
  width: 100%;
  text-align: center;
  font-size: 1em;
  color: #EEE;
  background: url('../../assets/top_bg.png') center center / 100%;
}

.header_medium {
  position: absolute;
  top: 35%;
  width: 100%;
  height: auto;
  text-align: center;
  font-size: 0.5em;
  color: #595959
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.header_right {
  position: absolute;
  top: 10%;
  right: 0;
  padding-left 1%
  padding-right 1%
  font-size: 0.5em;
  text-align: center;
  border: 4px whitesmoke;
  border-radius: 5px;
}

.left {
  position: relative;
  width: 35%;
  height: 100%;
  background-color: #41455D;
  display: flex;
  font-size 1em
  align-items flex-end
  justify-content: space-around;
  color: #ccc !important;
}

.medium {
  position: relative;
  top: 1%;
  background-color: transparent;
  display: flex;
  font-size 1em
  justify-content: space-around;
  color: #595959 !important;
}

.right {
  position: relative;
  width: 35%;
  height: 100%;
  background-color: #41455D;
  font-size 1em
  display: flex;
  align-items flex-end
  justify-content: space-around;
}

.header_project {
  position: absolute
  top: 60%
  left: 50%
  transform: translateX(-50%);
  width: auto
  height: 25%
  font-size 0.9em
}

a:active {
  border-bottom: 1px solid #08a5df;
  color: #08a5df !important
}

a {
  width: 25%;
  color: #a7a7a7;
  font-size: 1.2em;
  padding-top 1%
  padding-bottom 1%
  text-decoration: none;
}

.active {
  border-bottom: 1px solid #08a5df;
  color: #08a5df !important;
}

.time {
  background: #404040;
  color: #aaaaaa;
  width: auto;
  position: absolute;
  top: 10%;
  left: 0;
  padding-left 1%
  padding-right 1%
  font-size: 0.5em;
  text-align: center;
  border: 4px whitesmoke;
  border-radius: 5px;
}

.constractor {
  height: 83%;
  width: 100%;
  position: relative;
  text-align: center;
  margin 0 auto
  top: -5%;
  display: grid;
  grid-template-columns repeat(4, 24.5%)
  grid-template-rows repeat(3, 32.5%)
  place-content space-between space-between
}

.cons_item {
  position: relative
  font-size 1em
  text-align: center;
  line-height: auto
  background-color #31334a
}
</style>



// WEBPACK FOOTER //
// src/components/constractor/constractor.vue